module.exports = __webpack_public_path__ + "static/img/promotion-poster.668d46c7.jpg";